import React, { useState, useMemo, useRef } from 'react';
import ChartsIndex from '@/pages/intelligence/components/ChartsComponents/ChartsIndex';
import { ChartType } from '@/pages/intelligence/pages/TopCharts/_config/enums';
import { getPlatformName } from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/ActiveUserContext/_config/utils';
import useBarCharts from '@/pages/intelligence/components/Chart/hooks/useBarCharts';
import useLineCharts from '@/pages/intelligence/components/Chart/hooks/useLineCharts';
import { showTimeByDateType } from '@/pages/intelligence/utils/commonUtils';

// 每个榜单，组装好各类可视化需要的数据，传递给可视化统一组件
const Visualis: React.FC<any> = (props: any) => {
  const {
    chartType = ChartType.Bar,
    dateType,
    imageType,
    barSeriesData,
    lineData = [], // 折线 数据
    isNodata,
    chartSegment,
    barOrPieData,
    barNameList,
    topChartsType,
    titleNow,
    lineXAxisData,
  } = props;

  const cardRef = useRef(null);

  const [chartLoading, setChartLoading] = useState(true);

  const serData = useMemo(() => {
    if (Array.isArray(barSeriesData) && barSeriesData?.length > 0) {
      return barSeriesData?.slice(0, 5);
    }
    return barSeriesData;
  }, [barSeriesData]);

  const barDataTmp = useMemo(() => {
    if (Array.isArray(barOrPieData) && barOrPieData?.length > 0) {
      return barOrPieData?.slice(0, 5);
    }
    return barOrPieData;
  }, [barOrPieData]);

  const barNameListTmp = useMemo(() => {
    if (Array.isArray(barNameList) && barNameList?.length > 0) {
      return barNameList?.slice(0, 5);
    }
    return barNameList;
  }, [barNameList]);

  // 获取柱状图hooks
  const { barOption } = useBarCharts({
    seriesData: serData,
    setChartLoading,
    barOrPieData: barDataTmp,
    titleNow,
    barNameList: barNameListTmp,
    topChartsType,
    cardWidth: cardRef?.current?.clientWidth,
    ifNoBarImg: true,
  });

  // 组装rpd折线图数据
  const getRpdTypeData = (list: any, _platform = '') => {
    if (!Array.isArray(list) || list?.length < 1) return [];
    const arr: any = [];
    for (const i in list) {
      arr.push({
        metric: chartSegment,
        source: 'appannie',
        time: showTimeByDateType(list[i].date, dateType?.toLocaleLowerCase()),
        value: list[i].value,
      });
    }
    return arr;
  };

  const getMetricsList = (list: any) => {
    if (!Array.isArray(list) || list?.length < 1) return [];
    const arr: any = [];
    for (const n in list) {
      const objTemp = {
        cover: list[n].cover,
        id: list[n].app_id,
        name: `${list[n].name}(${getPlatformName(list[n]?.platform)})`,
        history: getRpdTypeData(list[n].history || [], list[n].platform),
      };
      arr.push(objTemp);
    }
    return arr;
  };

  const lineSeriesData = useMemo(() => {
    const arrGameData: any = {};
    for (const n in lineData) {
      arrGameData[lineData[n].metric] = getMetricsList(lineData[n].edition_time_line);
    }
    return arrGameData;
  }, [lineData]);

  // 获取折线图hooks
  const { lineOption } = useLineCharts({
    lineData: lineSeriesData,
    metric: chartSegment,
    topChartsType: 'stats-rpd-editions',
    imageType,
    titleNow,
    chartType: 'line',
    dateType,
    lineXAxisData,
  });

  return (
    <>
      <div className="card-line" ref={cardRef}>
        <ChartsIndex
          chartLoading={chartLoading}
          barOption={barOption}
          lineOption={lineOption}
          chartType={chartType}
          isNodata={isNodata}
        />
      </div>
    </>
  );
};

export default Visualis;
